import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgUploaderModule } from 'ngx-uploader';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  UbiThemeConfig
} from './theme.config';

import {
  UbiThemeConfigProvider
} from './theme.configProvider';

import {
  UbiBackTop,
  UbiCard,
  UbiCardBlur,
  UbiContentTop,
  UbiMenuItem,
  UbiMenu,
  UbiMsgCenter,
  UbiPageTop,
  UbiSidebar,
  UbiShellComponent,
  UbiLayoutListDetailComponent,
  UbiLayoutDataGridComponent,
  UbiLayoutDetailComponent,
  UbiFilterComponent
} from './components';

import {
  UbiScrollPosition,
  UbiSlimScroll,
} from './directives';

import {
  UbiProfilePicturePipe,
  FilterPipe
} from './pipes';

import {
  UbiMenuService,
  UbiFilterService
} from './services';

const UBI_COMPONENTS = [
  UbiBackTop,
  UbiCard,
  UbiCardBlur,
  UbiContentTop,
  UbiMenuItem,
  UbiMenu,
  UbiMsgCenter,
  UbiPageTop,
  UbiSidebar,
  UbiShellComponent,
  UbiLayoutListDetailComponent,
  UbiLayoutDataGridComponent,
  UbiLayoutDetailComponent,
  UbiFilterComponent
];

const UBI_DIRECTIVES = [
  UbiScrollPosition,
  UbiSlimScroll
];

const UBI_PIPES = [
  UbiProfilePicturePipe,
  FilterPipe
];

const UBI_SERVICES = [
  UbiMenuService,
  UbiFilterService
];

const UBI_VALIDATORS = [
];

@NgModule({
  declarations: [
    ...UBI_PIPES,
    ...UBI_DIRECTIVES,
    ...UBI_COMPONENTS
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgUploaderModule,
    NgbModule,
    InfiniteScrollModule
  ],
  exports: [
    ...UBI_PIPES,
    ...UBI_DIRECTIVES,
    ...UBI_COMPONENTS
  ]
})
export class UbiModule {
  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders> {
      ngModule: UbiModule,
      providers: [
        UbiThemeConfigProvider,
        UbiThemeConfig,
        ...UBI_VALIDATORS,
        ...UBI_SERVICES
      ],
    };
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/ubi.module.ts